module.exports = require("zlib");


//////////////////
// WEBPACK FOOTER
// external "zlib"
// module id = 187
// module chunks = 0